import React, { useEffect, useState } from 'react';
import useTranslation from '../../hooks/useTranslation';
import { useSelector } from 'react-redux';
import { create } from './table-schema';
import {getRankTargetTypeName, getRankTypeName, RANK_TYPE} from "../../constants/rank";

function useSchemaInAppRankSystem() {
  const { t } = useTranslation();
  const locale = useSelector((state) => state.language.locale);

  /**
   * 테이블 헤더에 표시할 항목 문자열 배열
   */
  const headerKeys = [
    "admin.app.fixAppData.inAppRankSystem.table.head.rankType", // "랭크 타입",
    "이름",
    "대상 타입", // "대상 타입",
    // "admin.app.fixAppData.inAppRankSystem.table.head.lastRank", // "표시 순위",
    // "admin.app.fixAppData.inAppRankSystem.table.head.withoutTarget", // "제외할 대상",
    // "admin.app.fixAppData.inAppRankSystem.table.head.update", // "업데이트",
  ];


  /**
   * 서버로부터 전달받은 request를 테이블에 표시할 내용으로 변환한다.
   *
   * 오브젝트 키는 param1, param10 등의 형식으로 param 다음에 숫자를 붙여서 사용한다.
   *
   * param1은 헤더의 첫번째 표시되는 항목이다.
   *
   * 헤더에는 표시되지 않지만 상세에 표시될 항목의 경우 headSize 이후의 숫자를 사용한다.
   *
   * key는 반드시 있어야 한다.
   * @param {object} row
   * @returns
   */
  const parse = (row) => {
    const settingNo = row?.settingNo;
    const rankType = row?.rankType;
    const lastRank = row?.lastRank;
    const targetType = row?.targetType;
    const withoutTarget = row?.withoutTarget;
    const updateComponent = <div className="update"></div>;
    const name = getRankTypeName(row?.rankType);
    const rankDetail = row?.rankDetail;

    return {
      key: settingNo, // 키는 반드시 있어야 한다.
      param1: rankType,
      param2: name,
      param3:  getRankTargetTypeName(row?.targetType),
      settingNo: settingNo,
      rankType: rankType,
      lastRank: lastRank,
      targetType: targetType,
      withoutTarget: withoutTarget,
      updateComponent: updateComponent,
      rankDetail: rankDetail,
    };
  };

  /**
   * 로그 데이터를 클릭했을 때 보여줄 디테일 다이얼로그에 보여줄 항목을 작성한다.
   *
   * 입력값인 row는 위의 parse에서 변환된 값이다.
   *
   * @param {object} row
   * @returns
   */
  const details = (row) => {
    const array = [];
    if (row) {
      //
    }
    return array;
  };

  const [schema, setSchema] = useState();

  useEffect(() => {
    const headers = headerKeys?.map((key) => t(key));
    const schema = create({
      heads: headers,
      parseFunc: parse,
      detailFunc: details,
    });
    setSchema(schema);
  }, [locale]);

  return { schema: schema };
}

export default useSchemaInAppRankSystem;
